<template>
  <div class="bg-white">
    <!-- <div class="bg-white" style="padding: 15px" v-loading="isLoading"> -->
    <el-tabs v-model="activeTab" type="card" id="stockIn_tabs">
      <el-tab-pane label="Step 1: Inspection Sheet" name="step_1">
        <inspection-sheet></inspection-sheet>
      </el-tab-pane>
      <el-tab-pane
        label="Step 2: Batch Information"
        :disabled="is_initial"
        name="step_2"
      >
        <batch-info></batch-info>
      </el-tab-pane>
      <el-tab-pane label="Documents" name="step_3" :disabled="is_initial">
        <!-- <batch-info></batch-info> -->
        <inspection-docs></inspection-docs>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PurchaseOrder from "@/models/PurchaseOrder";
import Supplier from "@/models/Supplier";
import InspectionSheet from "@/views/inventory/inspectionSheet.vue";
import BatchInfo from "@/views/inventory/batchInfo.vue";
import InspectionDocs from "@/views/inventory/docs.vue";
export default {
  name: "batch_info",
  components: { InspectionSheet, BatchInfo, InspectionDocs },
  beforeRouteUpdate(to, from, next) {
    if (!to.params || !to.params.id) {
      this.$store.dispatch("stockin/clearInspection");
    }
    next();
  },
  computed: {
    is_initial() {
      if (this.$store.getters["stockin/inspectionSheet"].id) return false;
      return true;
    }
  },
  data() {
    return {
      isLoading: false,
      po: new PurchaseOrder(),
      supplier: new Supplier(),
      activeTab: "step_1"
    };
  },
  methods: {},
  mounted() {
    this.$store.dispatch("supplier/getGlossary");
    if (this.$route.query && this.$route.query.tab) {
      this.activeTab = `step_${this.$route.query.tab}`;
    }
  }
};
</script>
<style lang="scss">
#stockIn_tabs .el-tabs__nav-scroll {
  background-color: #eaeaea;
  margin-left: -1px;
  .el-tabs__nav {
    background-color: #fff;
  }
}
</style>
